// extracted by mini-css-extract-plugin
module.exports = {"card":"card--1kYkr","card_img":"card_img--3QKSs"};